import axios from 'axios';
import CryptoJS from 'crypto-js';
import VueElementLoading from 'vue-element-loading';
import { BasicSelect, MultiSelect } from 'vue-search-select';
import Pagination from './../../../../shared/components/pagination';
import CustomExpandableTable from '../../../../shared/components/customExpandableTable';
import createtspbausers from './../createtspbausers';
import CONSTANT from './../../../../shared/constants/constant';
import Utility from '../../../services/utility.service';
import Util from '../../../../shared/util/util';

export default {
  name: 'tspbauserslisting',
  components: {
    VueElementLoading,
    BasicSelect,
    Pagination,
    CustomExpandableTable,
    createtspbausers
  },
  props: [],
  data() {
    return {
      showtspbausersData: false,
      isLoading:false,
      olddeliveryuserid: '',
      totalCount: 0,
      currentPage: 1,
      totalPage: 0,
      totalCount: 0,
      offset: 0,
      pageLimit: CONSTANT.PER_PAGE_DATA,
      tableColumn: ['User Id','User Name','Email','First Name','Created By',
      'Created Date','Last Modified By','Last Modified Date','Status ', 'Action'],
      tableItems: [],
      innerTableColumn: [],
      selectedtspbauserObj: [],
      tspbauserDetails:"",
    }
  },
  computed: {},
  async mounted() {
    await this.getTSPBAUserlist();
  },
  methods: {
    showTspbauserData() {
      this.selectedtspbauserObj = [];
      this.showtspbausersData = true;
    },
    callParent() {
        this.showtspbausersData = false;
        this.selectedtspbauserObj = [];
        this.currentPage = 1;
        this.offset = 0;
        this.getTSPBAUserlist("");
    },
    onPageChange(page) {
      this.currentPage = page;
      this.offset = (page - 1) *this.pageLimit
      this.getTSPBAUserlist();
    },
    getCustomTableEvent(event) {
      if(event.actionType=="edit"){
        let selectedtspbauserObj  = this.tableArr.filter(function(Items) {
          return Items.userid == event.id;
        });
        this.selectedtspbauserObj = selectedtspbauserObj[0];
        this.showtspbausersData = true;
      }
    },
    searchTSPBAUserDetails(){
      this.currentPage = 1;
      this.offset = 0;
      this.getTSPBAUserlist();
    },
    resetTSPBAUserDetails(){
      this.currentPage = 1;
      this.offset = 0;
      this.olddeliveryuserid= "";
      this.getTSPBAUserlist();
    },
    async getTSPBAUserlist(){
      try {
        this.isLoading = true;
        let inputPayload = {
          "offset": this.offset,
          "limit": this.pageLimit
        }
        if(this.olddeliveryuserid!=""){
          inputPayload.olddeliveryuserid = this.olddeliveryuserid;
        }
        let result = await Utility.getTSPBAUserlist(inputPayload);
        this.tableArr = result.data.data.rows;
        this.totalCount = result.data.data.count;
        if(this.totalCount>0){
          this.tableItems = result.data.data.rows.map((el)=>{
            return {
              'id':el.userid,
              'User Id':el.userid,
              'User Name':el.username,
              'Email': el.email,
              'First Name':el.FirstName,
              'Created By':el.createdby,
              'Created Date':Util.displayDateTimeFormat(el.createddatetime),
              'Last Modified By':el.modifiedby,
              'Last Modified Date':(el.modifieddatetime)?Util.displayDateTimeFormat(el.modifieddatetime):null,
              'Status ':el.status,
              'Action': 'Need To Check1'
            }
          })
        }else{
          this.tableItems = [];
        }
        if (this.totalCount < this.pageLimit) {
          this.totalPage = 1
        } else {
          this.totalPage = Math.ceil(this.totalCount / this.pageLimit);
        }
        this.isLoading = false;
      } catch(err){
        console.log(err);
        this.isLoading = false;
      }
    },
  }
}



// WEBPACK FOOTER //
// ./src/modules/utility/views/tspbausers/tspbauserslisting/tspbauserslisting.component.js